import { RemoteStoresService } from './remote-stores.service';

export default angular
  .module('sfMobile.services.remote-stores', [
    'sfMobile.services.preferences',
    'sfMobile.services.pubsub',
  ])
  .service('remoteStoresService', RemoteStoresService).name;
